import useEventAwaiting from '@client:common/hooks/useEventAwaiting';
import { UUID } from 'crypto';
import { useState } from 'react';


export default function useChatAnimationCoordinator() {
  const [stagedUserMessageId, setStagedUserMessageId] = useState<UUID | null>(null);
  const [stagedUserMessageContent, setStagedUserMessageContent] = useState<string | null>(null);
  const [stagedFlowMessageIndex, setStagedFlowMessageIndex] = useState<number | null>(null);

  const [userMessageAnimationDidFinish, handleUserMessageAnimationFinish] = useEventAwaiting();
  const [userMessageDidFinishStagingAnimation, handleUserMessageDidFinishStagingAnimation] = useEventAwaiting();
  const [flowMessageAnimationDidFinish, handleFlowMessageAnimationFinish] = useEventAwaiting();

  const withNextRender = (callback: () => void) => {
    setTimeout(callback, 0);
  }

  const withStagedUserMessage = async (content: string, callback: (nextMessageId: UUID) => Promise<void>) => {
    const nextMessageId = crypto.randomUUID();

    setStagedUserMessageId(nextMessageId);
    setStagedUserMessageContent(content);

    await userMessageDidFinishStagingAnimation();

    await callback(nextMessageId);

    setStagedUserMessageId(null);
    setStagedUserMessageContent(null);
  }

  const withStagedFlowMessage = async (selectionIndex: number, callback: (nextMessageId: UUID) => Promise<void>) => {
    const nextMessageId = crypto.randomUUID();

    setStagedFlowMessageIndex(selectionIndex);

    await callback(nextMessageId);

    setStagedFlowMessageIndex(null);
  }

  return {
    withNextRender,

    stagedUserMessageId,
    stagedUserMessageContent,
    withStagedUserMessage,

    stagedFlowMessageIndex,
    withStagedFlowMessage,

    userMessageAnimationDidFinish,
    handleUserMessageAnimationFinish,

    userMessageDidFinishStagingAnimation,
    handleUserMessageDidFinishStagingAnimation,

    flowMessageAnimationDidFinish,
    handleFlowMessageAnimationFinish,
  }
}
